import { render } from "./NewAddAuctionSecondView.vue?vue&type=template&id=453f4ff5&scoped=true&ts=true"
import script from "./NewAddAuctionSecondView.vue?vue&type=script&lang=ts"
export * from "./NewAddAuctionSecondView.vue?vue&type=script&lang=ts"

import "./NewAddAuctionSecondView.vue?vue&type=style&index=0&id=453f4ff5&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-453f4ff5"]])

export default __exports__